import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { Button } from "@material-ui/core";
import {
    ArrowBack as BackIcon,
    ArrowForward as ForwardIcon
} from "@material-ui/icons";

import { hot } from "react-hot-loader";
import {
    setWeekCount,
    incrementWeekStart,
    decrementWeekStart
} from "./actions";
import { selectWeekCount } from "./selectors";

const StyledButton = styled(Button)`
    grid-column-start: ${props => props.column};
    grid-column-end: ${props => props.column};
    max-height: 20px;
    min-height: 0px !important;
    max-width: 20px;
    min-width: 0px !important;
    width: 30px;
    height: 20px;
    padding: 0px !important;
    color: white;
    padding-left: 7px !important;
`;

const IconStyles = css`
    max-width: 18px;
    max-height: 18px;
    color: white;
`;
const StyledBackIcon = styled(BackIcon)`
    ${IconStyles}
`;

const StyledForwardIcon = styled(ForwardIcon)`
    ${IconStyles}
`;

const ControlCellContainer = styled.div`
    grid-template-rows: 1fr;
    grid-template-columns: 0.6fr 2fr 0.4fr;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    display: grid;
    padding-top: 6px;
`;

const Select = styled.select`
    border: none;
    height: 19px;
    width: 100%;
    border-radius: 2px;
    font-size: 12px;
    appearance: none;
    text-align: center;
    text-align-last: center;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 2;
    grid-column-end: 2;
`;

class DayCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            editRowCellModalOpen: false,
            confirmDeleteModalOpen: false
        };
    }
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleChange = event => {
        this.props.setWeekCount(event.target.value);
    };
    render() {
        return (
            <ControlCellContainer>
                <Select
                    onChange={this.handleChange}
                    value={this.props.weekCount}
                >
                    <option value={1}>1 Week</option>
                    <option value={2}>2 Weeks</option>
                </Select>
                <StyledButton
                    variant="flat"
                    column={1}
                    onClick={this.props.decrementWeekStart}
                >
                    <StyledBackIcon />
                </StyledButton>
                <StyledButton
                    variant="flat"
                    column={3}
                    onClick={this.props.incrementWeekStart}
                >
                    <StyledForwardIcon />
                </StyledButton>
            </ControlCellContainer>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            store => {
                return {
                    weekCount: selectWeekCount(store)
                };
            },
            { setWeekCount, incrementWeekStart, decrementWeekStart }
        )(DayCell)
    )
);
